import React, {  useEffect, useRef } from 'react';
import useState from 'react-usestateref';
import '../index.css';
import Navbar from '../components/Navbar';
import Spinner from '../Spinner';
import {
    generateSqlWithAgentAi, querySqlRustService,wrietSqlResultToFile,copyFile,
    fetchTableRust, fetchSqliteListColumns, createNewReport, readEachReportData,
    listOfFileNamesPageDir,fetchTableColumnsRust
} from '../authorization/FetchToken';
import { useNavigate } from 'react-router-dom'; 
import { Editor } from '@monaco-editor/react';
import CodeMirror from '@uiw/react-codemirror';
import { sql } from '@codemirror/lang-sql';
import { autocompletion } from '@codemirror/autocomplete';
import { EditorView } from '@codemirror/view';
import debounce from "lodash.debounce";
import TextField from "@mui/material/TextField";
import ErrorDialog from "../grid/ErrorDialog"
import { useAuth } from './AuthContext';
import InfoTip from "../components/InfoTip";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import Drawer from "@mui/material/Drawer";


import {
  Typography,
  Divider,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Button } from "@mui/material";
import { Box, IconButton, Tooltip,InputAdornment } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {SuccessButton,CancelButton,BuildButton} from "../components/buttons.js";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";


function QueryEditorPage() {
    const connectionType = 'SQLite';
    let llmInitConName='';
    let schemasList = [];
    let tableList = [];
    let columnList = [];
    let currentTableName;
    let columnTypeList = [];
    let partitionByValue;
    let orderByValue;
    let selectedTableColumnsValue = [];
    //let connectionName = "kafka_test_5";
    const [messages, setMessages,ref] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const [loading, setLoading] = useState(false);

    //const [catalog, setCatalog] = useState('');
    const [selectedDatabase, setSelectedDatabase] = useState('');
    const [selectedTable, setSelectedTable] = useState('');
    const [leftList, setLeftList] = useState([]);
    const [rightList, setRightList] = useState([]);
    const [tableDataList, setTableDataList] = useState(tableList.length > 0 ? tableList : []);
    const [columnDataList, setColumnDataList] = useState(columnList.length > 0 ? columnList : []);
    const [selectedTableColumns, setSelectedTableColumns] = useState(
        selectedTableColumnsValue && selectedTableColumnsValue.length > 0 ? selectedTableColumnsValue : ' ');
    const [orderBy, setOrderBy] = useState(
        orderByValue && orderByValue.length > 0 ? orderByValue : ' ');
    const [partitionBy, setPartitionBy] = useState(
        partitionByValue && partitionByValue.length > 0 ? partitionByValue : ' ');
    const [columnTypeListValue, setColumnTypeListValue] = useState(columnTypeList.length > 0 ? columnTypeList : []);
    const [selectedCells, setSelectedCells] = useState([]);
    const [jsonCopy, setJsonCopy,jsonCopyRef] = useState({});

    const [model, setModel] = useState("claude-haiku-4-5-20251001"); 
    const [apiKey, setApiKey] = useState("");
    const [showKey, setShowKey] = useState(false);
    const [jsonData, setJsonData,jsonDataRef] = useState([]);
    const navigate = useNavigate();
    const [apiError, setApiError,apiErrorRef] = useState('');
    const [fileType, setFileType] = useState('csv');
    const [fileName, setFileName] = useState('');
    //const [queryDescription, setQueryDescription] = useState("");
    const [queryDescription, setQueryDescription] = useState(() => {
      return localStorage.getItem("queryDesc") || "";
    });
    let json = {};
    let selectedTableName;
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [error, setError] = useState(''); // Error message state
  const [showErrorPopup, setShowErrorPopup] = useState(false); // Error popup visibility state
  const [gridData, setGridData] = useState([]);
  const [value, setValue,valueRef] = useState('');
  const editorRef = useRef(null);
  let execSqlStatement = false;
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);
  const [loggedInUserRole,setloggedInUserRole] = useState("")
  const [openDoc, setOpenDoc] = useState(false);
  const [doc, setDoc] = useState("");
  
const { userSessionRef} = useAuth();

useEffect(() => {
  if (!userSessionRef) return;
      fetchListDataConnections();
  }, [userSessionRef]);
    
useEffect(() => {
  if (!userSessionRef) return;
}, [leftList,userSessionRef]);

const defaultAdvancedJson = JSON.stringify({
    temperature:"",
    top_p: "",
    max_tokens: "",
    do_sample: "",
    stop: [""]
}, "", 2);

const [advancedParamsJson, setAdvancedParamsJson] = useState(defaultAdvancedJson);

const renderSchemaOptions = () => {
  return jsonDataRef.current?.map((file, index) => (
      <option key={index} value={file.path}>
        {file.info?.name || file.path}
      </option>
  ));
  
};

const renderTable1Options = () => {
        return tableDataList.map((table, index) => (
            <option key={index} value={table}>
                {table}
            </option>
        ));
    };

const readData = async (leftList,tableName) => {
        //console.log("leftList::4", leftList)
        const filteredList =[];
        //const tableName = `${connectionName}.${selectedDatabase}.${selectedTable}`
        try {
            
            //const token = await fetchToken();
            const reportData = await readEachReportData(
                "default_user",
                tableName,
                userSessionRef.current["orgName"]
            );
        //console.log("reaData::1",JSON.stringify(leftList));
        //console.log("reaData::2", reportData,tableName);
    if (reportData !== undefined) {
        leftList.forEach(columnName => {
            const filteredItems = reportData[tableName]?.filter(item => item.name === columnName[0]) || [];

            if (filteredItems.length > 0) {
                filteredItems.forEach(item => {
                    filteredList.push({
                        "name": columnName[0],
                        "dataType": columnName[1],
                        "description": item.description
                    });
                });
            } else {
                filteredList.push({
                    "name": columnName,
                    "dataType": "",
                    "description": ""
                });
            }
        });
      
        //console.log("l1::1", filteredList)
    } else {
            leftList.forEach(column => {
                filteredList.push({ "name": column[0], "dataType": column[1], "description": "" });
                //console.log("l1::2", filteredList)
            });
            //console.log("l1::2", filteredList)
    }
        //console.log("l::3", filteredList)
        json[tableName]=filteredList;
        //console.log("l::4", json)
        setJsonCopy(json)
        return filteredList
        //setRightList(filteredList)
        //console.log("l::4", rightList)
    } catch (error) {
        console.error('Error:', error);
        return [];
     }
  }

const fetchListDataConnections = async () => {
        try {
          const path =  `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` +  userSessionRef.current["orgName"] + "/databases";
          const  connectionsDataResp= await listOfFileNamesPageDir(path);
          //console.log("data:222",connectionsDataResp);
          const databases = connectionsDataResp.children || [];
          const connectionsData = databases.filter(item =>
            typeof item.path === "string" &&
            !item.path.includes("-shm") &&
            !item.path.includes("-wal") &&
            !item.path.includes(".db-shm") &&
            !item.path.includes(".db-wal")
          );
          
          //console.log("data:22",JSON.parse(JSON.stringify(connectionsData[0]))?.path);
          const firstdatabase = JSON.parse(JSON.stringify(connectionsData[0]))?.path;
          const event = {"target":{"value":firstdatabase}};
          //console.log("data:221",event.target.value);
          handleDatabaseChange(event)
          setJsonData(connectionsData);
        } catch (error) {
          console.error('Error fetching sqlite databases:', error);
        }
};

const handleDatabaseChange = async (event) => {
    const schema = event.target.value;
    //console.log("data:33",schema,event);

    setLoading(true);
    setSelectedDatabase(schema);
    let tableNames = [];
    let columnNames = [];
    //tableNames = await fetchSqliteListTables(schema);
    try {
      const tableNames = await fetchTableRust(
          schema,
          `SELECT name FROM sqlite_schema WHERE type='table' ORDER BY name`,
          userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, ''),
          userSessionRef.current["orgName"]
      );

  
      // use directly
      //console.log("tables:", tableNames);
  
    //console.log("tableNames::1", tableNames);
    setSelectedTable(tableNames[0]);
    setTableDataList(tableNames);
    if (tableNames && tableNames.length > 0) {
        const tableName = JSON.parse(JSON.stringify(tableNames[0]));
        //console.log("tableNames::2",tableName);
        columnNames =  await fetchTableColumnsRust(schema, `pragma table_info(${tableName});`,userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, ''),userSessionRef.current["orgName"],'');
        //console.log( "columnNames::1", schema,JSON.stringify(columnNames));
        setLeftList(columnNames.map(leftList => JSON.parse(JSON.stringify(leftList[0]))));
        //const tableName = `${schema}.${tableNames[0]}`;
        currentTableName = tableName;
        //console.log("leftList::3", leftList,columnList);
        let database = schema;
        if (connectionType == 'SQLite'){
            database= database.replaceAll("/",".")  
        };
        //const tableName = `${selectedDatabase}.${selectedTable}`   
        const fullTableName = `${database}.${tableName}`      
        const res = await readData(columnNames, fullTableName);
        setRightList(res);
        //  const columns = selectedTable.columns;
        setSelectedTableColumns(columnNames[0]);
        setColumnTypeListValue(columnNames[1]);
        // setSelectedTableColumns(response[0][0]);
        setOrderBy(columnNames[0][0]);
        //setShowWindowFunction(false);
        setPartitionBy(columnNames[0][0]);
    }

    setLoading(false);
    
  } catch (err) {
    console.error("Error:", err);

    const message =
        err instanceof Error ? err.message : String(err);

    if (message.toLowerCase().includes("quota")) {
        setLoading(false);
        setErrorMessage(message);
        setShowErrorMessage(true);
        return;
    }
    
    setLoading(false);
    setErrorMessage(message);
    setShowErrorMessage(true);
}

    };


const handleTableChange = async (event, selectedTable) => {
    selectedTableName = event.target.value;
    setLoading(true);
    setSelectedTable(selectedTableName);

    let columnNames = [];
    columnNames = await fetchSqliteListColumns(selectedDatabase, selectedTableName);
    //console.log("columnNames::4",JSON.stringify(columnNames));
    setLeftList(columnNames.map(leftList => JSON.parse(JSON.stringify(leftList[0]))));
    setColumnDataList(columnNames.map(column => column[0]));
    //const tableName = `${selectedDatabase}.${selectedTableName}`;
    currentTableName = selectedTableName;
    //console.log("tableName::3", tableName);
    let fullTableName = `${selectedDatabase}.${selectedTableName}` 
    if (connectionType == 'SQLite'){
      fullTableName= fullTableName.replaceAll("/",".")  
  }; 
    const res = await readData(columnNames, fullTableName);
    setRightList(res);
    setSelectedTableColumns(columnNames[0]);
    setColumnTypeListValue(columnNames);
    setOrderBy(columnNames[0][0]);
    //setShowWindowFunction(false);
    setPartitionBy(columnNames[0][0]);

    setLoading(false);
    };
    
//const j = { "kafka_test_5.information_schema.applicable_roles": { "grantee": { "dataType": "value1", "description": "description1" }, "grantee_type": { "dataType": "value2", "description": "description2" } } }
const handleInputChange = async (index, field, value) => {
        let tableName = `${selectedDatabase}.${selectedTable}`
        currentTableName = tableName;
        //console.log("handleInputChange_json::10", tableName, index, field, value,rightList,index)
        const col = rightList[index]["name"]
        //console.log("handleInputChange_json::1", jsonCopy)
        //j[tableName][col][field]=value
        if (connectionType == 'SQLite'){
            tableName= tableName.replaceAll("/",".")  
        };
        let updatedJson
        if (jsonCopy!=undefined && jsonCopy[tableName]!==undefined){   
        //console.log("in update json::1", JSON.stringify(jsonCopy))
        updatedJson = {
            ...jsonCopy,
            [tableName]: jsonCopy[tableName].map(item =>
                item.name === col ? { ...item, [field]: value } : item
            )
        };
            //console.log("in update json::2  ", updatedJson)
        json = updatedJson;
        setJsonCopy(updatedJson);
    } else{
          //console.log("in new json::1", json,tableName,value)
          //console.log("in update json::2  ", updatedJson)
          updatedJson = {
            ...jsonCopy,
            [tableName]: jsonCopy[tableName].map(item =>
                item.name === col ? { ...item, [field]: value } : item
            )
        }
          //json = { [tableName]:[{[field]:value}]};
        json = updatedJson;
        setJsonCopy(updatedJson);

    }
  
        //console.log("handleInputChange::10", tableName, index, field, value)
        //console.log("handleInputChange::2", updatedJson)
        //setJson(updatedJson);
        //console.log("handleInputChange::3", jsonCopy)
        //console.log("createJson::2", jsonCopy)
        //setRightList(index, field, value)
        setRightList(rightList.map((column, i) => i === index ? { ...column, [field]: value } : column));
        //console.log("handleInputChange::2", rightList)
    };

const handleDragStart = (event, value) => {
        //console.log("handleDragStart::1", event, value)
        event.dataTransfer.setData('text/plain', value);
        //console.log("handleDragStart::2", event.dataTransfer.getData('text/plain'))
        //setInputMessage(`Column ${value} from table  and description`);

    };

    const handleDrop = (event) => {
      event.preventDefault();
    
      const raw = event.dataTransfer.getData('text/plain');
    
      if (!raw) return;
    
      try {
        const column = JSON.parse(raw);
        //console.log("handleDrop::1", column);
      } catch (err) {
        console.warn("Invalid drop data:", raw);
        return; //ignore invalid drops
      }
    };
  
  function AlertBanner({ message, onClose }) {
        if (!message) return null;
      
        return (
          <div style={{
            backgroundColor: '#fdecea',
            color: '#611a15',
            padding: '10px 20px',
            border: '1px solid #f5c6cb',
            borderRadius: '5px',
            marginBottom: '1rem',
            position: 'relative'
          }}>
            <span>{message}</span>
            <button
              onClick={onClose}
              style={{
                position: 'absolute',
                top: '5px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '16px',
                color: '#611a15',
                cursor: 'pointer'
              }}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        );
      }

const handleCreate = async (e) =>{
        e.preventDefault();
        setLoading(true);
        currentTableName = `${selectedDatabase}.${selectedTable}`
        let database = selectedDatabase;
        try {
            if (connectionType == 'SQLite'){
                database= database.replaceAll("/",".")  
            };
            //const tableName = `${selectedDatabase}.${selectedTable}`   
            const tableName = `${database}.${selectedTable}`    
            //console.log("tableName::1",tableName)
            
            //console.log("handleCreate::1",  tableName, jsonCopyRef.current)
            //const token = await fetchToken();
            const newReportData = await createNewReport("default_user", tableName, jsonCopy,userSessionRef.current["orgName"]);
        } catch (error) {
            console.error('Error fetching connections:', error);
        }
        setLoading(false)
    }

  const [sqlQuery, setSqlQuery] = useState('');
  const [resultRows, setResultRows] = useState([]);
  const [resultCols, setResultCols] = useState([]);

const handleExecuteRust = async () => {
    setLoading(true);
    //console.log('handleExecuteRust::100')
    try {
      //console.log('handleExecuteRust::200')
      const view = editorRef.current;
      //console.log('handleExecuteRust::300',view)
      if (!view) return;
      const selectedText = view.state.sliceDoc(
        view.state.selection.main.from,
        view.state.selection.main.to
      );
      //console.log('handleExecuteRust::400')
      const query = selectedText.trim() !== '' ? selectedText : value;
      //console.log('handleExecuteRust::500')
      //console.log('handleExecuteRust::1', query);
      const cpFuntionsFile = await copyFile("/home/stateFiles/" +`${userSessionRef.current["orgName"]}` + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/functions/functions" , `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}/functions/functions`,userSessionRef.current["orgName"])
  
      const json = await querySqlRustService(selectedDatabase, query,userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, ''),userSessionRef.current["orgName"],'');
      //console.log('handleExecuteRust::11',json);

      if (!json.results) {
        setError(JSON.stringify(json, null, 2));
      }
      const data = json.results;
  
      //console.log('handleExecuteRust::112', JSON.stringify(data));
      if (!Array.isArray(data) || data.length < 1) {
        throw new Error("Empty or invalid result from Rust SQL engine");
      }
  
      // First row is header
      const [columns, ...rows] = data;
      //console.log('handleExecuteRust::raw output::2', columns);
  
      // Use in React Table
      setResultCols(columns);  // ['col1', 'col2', ...]
      setResultRows(rows);     // [['val1', 'val2', ...], ...]
  
    } catch (err) {
      setResultCols([]);
      setResultRows([]);
      //alert(`Execution error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

const handleExecuteWriteFile = async () => {
    if (!fileName || fileName.trim() === "") {
      setErrorMessage("File Name cannot be empty.")
      setShowErrorMessage(true)
      return;
    }
    setLoading(true);
    try {
      const view = editorRef.current;
      if (!view) return;
      const selectedText = view.state.sliceDoc(
        view.state.selection.main.from,
        view.state.selection.main.to
      );
      const query = selectedText.trim() !== '' ? selectedText : value;
     //console.log('Running SQL::1', query);
      const data = await wrietSqlResultToFile(selectedDatabase, query, fileName, fileType,userSessionRef.current["orgName"]);
      const text = await data.text();
      if (!data.ok) {
        setError(text);
      } else {
        setSuccessMessage(`Result written successfully to file '${fileName}'`);
        setShowSuccessMessage(true)
      }
      
    } catch (err) {
      setResultCols([]);
      setResultRows([]);
      //alert(`Execution error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  if (!userSessionRef) return;
        fetch(`${process.env.REACT_APP_SQL_GENERATOR}/readStateFile`, {
            method: 'POST',
            headers: {
                'Content-Type': `${process.env.REACT_APP_CONTENT_TYPE}`,
                'Authorization': localStorage.getItem("jwtToken")
            },

            body: JSON.stringify({
                org_name: userSessionRef.current["orgName"],
                architecture_name: `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
                state_type: `${process.env.REACT_APP_STATE_TYPE_REPORTS}`,
                connection_name:`${userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '')}`,
                file_name: "query_editor/queries",
            })


        }).then((res) => res.text())
        .then((data) => setValue(data))
        .catch(console.error);;
  
    }, [userSessionRef]);

const debouncedSave = useRef(null);

useEffect(() => {
  if (!userSessionRef) return;
  debouncedSave.current = debounce((val) => {
    //console.log("HANDLE SAVE CALLED", val);

    fetch(`${process.env.REACT_APP_SQL_GENERATOR}/createStateFile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("jwtToken")
      },
      body: JSON.stringify({
        org_name: userSessionRef.current["orgName"],
        architecture_name: process.env.REACT_APP_ARCHITECTURE_NAME,
        state_type: process.env.REACT_APP_STATE_TYPE_REPORTS,
        connection_name: `${userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, "")}/query_editor`,
        file_name: "queries",
        file_content: val,
      }),
    }).catch(console.error);
  }, 1000);

  return () => {
    debouncedSave.current?.cancel();
  };
}, []); // ← MUST be empty


const hasMounted = useRef(false);

const onDocChange = EditorView.updateListener.of((update) => {
  if (!update.docChanged) return;

  const val = update.state.doc.toString();
  setValue(val);

  if (!hasMounted.current) {
    hasMounted.current = true;
    return;
  }

  debouncedSave.current?.(val);
});


const handleChange = (val) => {
  //console.log("handleChange fired");
  setValue(val);
  debouncedSave.current?.(val);
};


  const handleAgentAi = async () => {
    if (!apiKey || apiKey.trim() === "") {
      setErrorMessage("API Key cannot be empty.")
      setShowErrorMessage(true)
      return;
    }
    setLoading(true);

    const resp = await generateSqlWithAgentAi(queryDescription,model,apiKey,userSessionRef.current["orgName"]) 

    //console.log("AgentAiresp::101",resp)
    if (resp==undefined || resp.includes("Error")){
      setErrorMessage(resp);
      setShowErrorMessage(true)
    } else {
      const inner = JSON.parse(resp);
      //console.log("generateSqlWithAgentAi::12",resp)
      setValue((prev) => prev + "\n" + inner.query);
      //debouncedSave(valueRef.current);
    }

    setLoading(false)
  };

  return (
    <div className="main-container">

{showSuccessMessage && (
  <div
    className="success-message"
    id="success-banner"
    style={{
      position: "relative",
      backgroundColor: "#dcfce7",
      color: "#166534",
      padding: "12px 40px 12px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <span>✅ {successMessage}</span>
    <button
      onClick={() => setShowSuccessMessage(false)}
      style={{
        position: "absolute",
        top: "8px",          // moves it to the top
        right: "10px",       // aligns it to the right edge
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#b91c1c",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "0", 
      }}
    >
      ×
    </button>
  </div>
)}

    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", fontFamily: "Inter, sans-serif" }}>
      <AlertBanner message={apiErrorRef.current} onClose={() => setApiError("")} />
    
    {showErrorMessage && (
    <div
      className="error-message"
      id="error-banner"
      style={{
        position: "relative",
        backgroundColor: "#fee2e2",
        color: "#b91c1c",
        padding: "12px 40px 12px 12px",
        borderRadius: "6px",
        marginBottom: "12px",
        fontWeight: 500,
        fontSize: "14px",
      }}
    >
      <span>ERROR OCCURRED: {errorMessage}</span>
      <button
        onClick={() => setShowErrorMessage(false)}
        style={{
          position: "absolute",
          top: "8px",          // moves it to the top
          right: "10px",       // aligns it to the right edge
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "#b91c1c",
          fontSize: "18px",
          fontWeight: "bold",
          lineHeight: "0", 
        }}
      >
        ×
      </button>
    </div>
  )}  
  
      {loading && (
        <div className="overlay">
          <div className="loading-container">
            <Spinner />
            <p className="please-wait">Please wait...</p>
          </div>
        </div>
      )}
  
      <div
        className="page-container"
        style={{
          display: "flex",
          gap: "16px",
          padding: "16px 24px",
          height: "calc(100vh - 80px)",
        }}
      >
        {/* LEFT PANEL */}
        <div
          className="popup-datatable-container"
          style={{
            width: "340px",
            backgroundColor: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            overflowY: "auto",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <h3 style={{ fontSize: "16px", fontWeight: 600, marginBottom: "12px", color: "#111827" }}>
            Explore Tables
          </h3>
          <InfoTip
        keyword="query_editor"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
          </div>
  
          <label style={{ fontWeight: 500, fontSize: "13px", color: "#374151" }}>Database</label>
          <select
            id="database"
            className="form-control"
            value={selectedDatabase}
            onChange={handleDatabaseChange}
            style={{
              padding: "6px",
              fontSize: "13px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              marginBottom: "10px",
            }}
          >
            {renderSchemaOptions()}
          </select>
           
          <label style={{ fontWeight: 500, fontSize: "13px", color: "#374151" }}>Table</label>
          <select
            id="table"
            className="form-control"
            value={selectedTable}
            onChange={handleTableChange}
            style={{
              padding: "6px",
              fontSize: "13px",
              borderRadius: "6px",  
              border: "1px solid #d1d5db",
              marginBottom: "12px",
            }}
          >
            {renderTable1Options()}
          </select>
  
  {selectedTable && (
          <IconButton
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData("text/plain", `SELECT * FROM ${selectedTable}`);
              e.dataTransfer.effectAllowed = "copy";
            }}
            onClick={() => {
                setValue((prev) => prev + `\nSELECT * FROM ${selectedTable}`);
            }}
            size="small"
            sx={{
              border: "1px dashed #cbd5e1",
              borderRadius: "6px",
              backgroundColor: "#f1f5f9",
              color: "#1e293b",
              fontSize: "12px",
              padding: "2px",
              transition: "background-color 0.2s ease",
              "&:hover": {
                backgroundColor: "#e2e8f0",
              },
              cursor: "grab",
              marginTop: "5px",
            }}
          >
            <span style={{ fontSize: "11px", fontWeight: 500, cursor: "pointer" }}>Generate SQL</span>
          </IconButton>
    )}
          <button
            onClick={fetchListDataConnections}
            style={{
              padding: "6px 10px",
              fontSize: "13px",
              backgroundColor: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "0.2s",
            }}
          >
            Refresh
          </button>
  
          <div style={{ flex: 1, overflowY: "auto", marginTop: "25px" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "12px",
                color: "#111827",
              }}
            >
              <thead style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                <tr>
                  <th style={{ padding: "6px", borderBottom: "1px solid #e5e7eb" }}>Column</th>
                  <th style={{ padding: "6px", borderBottom: "1px solid #e5e7eb" }}>Type</th>
                  <th style={{ padding: "6px", borderBottom: "1px solid #e5e7eb" }}>Description</th>
                </tr>
              </thead>
              <tbody>
                {rightList.map((column, index) => (
                  <tr key={index}>
                    {["name", "dataType", "description"].map((field) => (
                      <td key={field} style={{ padding: "4px" }}>
                        <input
                          type="text"
                          value={column[field]}
                          draggable
                          onDragStart={(e) => handleDragStart(e, e.target.value)}
                          onDrop={(e) => handleDrop(e, e.target.value)}
                          onChange={(e) => handleInputChange(index, field, e.target.value)}
                          style={{
                            width: "110%",
                            padding: "4px",
                            fontSize: "12px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "4px",
                          }}
                        />
                      </td>
                      
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
  
          <button
            onClick={handleCreate}
            style={{
              marginTop: "14px",
              padding: "6px",
              backgroundColor: "#16a34a",
              color: "white",
              fontSize: "13px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Save Description
          </button>
        </div>
  
        {/* RIGHT PANEL */}
<div
  style={{
    flex: 1,
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    height: "100%",        // ensures vertical fill
    overflow: "hidden",    // prevent double scrollbars
  }}
>
  {/* QUERY EDITOR */}
  <div style={{ flexShrink: 0 }}>
    <CodeMirror
      value={value}
      height="280px"
      theme="light"
      extensions={[sql(), autocompletion(), EditorView.lineWrapping,onDocChange]}
      onCreateEditor={(view) => {
        editorRef.current = view;
      }}
    />
  </div>

  {/* BUTTONS */}
  <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexShrink: 0 }}>
    <button
      onClick={handleExecuteRust}
      disabled={loading}
      style={{
        backgroundColor: "#2563eb",
        border: "none",
        color: "white",
        padding: "6px 10px",
        borderRadius: "6px",
        fontSize: "13px",
      }}
    >
      ▶ {loading ? "Running..." : "Execute SQL"}
    </button>
  </div>

  {/* Model Selection */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "16px",              // consistent horizontal space
    marginTop: "16px",
    fontSize: "13px",
  }}
>
  {/* Model Dropdown */}
  <FormControl size="small" sx={{ width: "220px" }}>
    <InputLabel>LLM Model</InputLabel>
    <Select
      value={model}
      onChange={(e) => setModel(e.target.value)}
      label="LLM Model"
      sx={{
        borderRadius: "8px",
        fontSize: "13px",
        "& .MuiSelect-select": { paddingY: "6px" },
      }}
    >
      <MenuItem value="claude-haiku-4-5-20251001">claude-haiku-4-5-20251001</MenuItem>
      <MenuItem value="gpt-4o-mini">gpt-4o-mini (OpenAI)</MenuItem>
    </Select>
  </FormControl>

  {/* API Key Input */}
  <TextField
    placeholder="API Key"
    size="small"
    type={showKey ? "text" : "password"}
    value={apiKey}
    onChange={(e) => setApiKey(e.target.value)}
    sx={{
      flex: 1, // take remaining space
      "& .MuiInputBase-root": {
        borderRadius: "6px",
        fontSize: "13px",
      },
      "& input::placeholder": {
        fontSize: "12px",
        opacity: 0.7,
      },
    }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            onClick={() => setShowKey(!showKey)}
            edge="end"
            size="small"
            aria-label="toggle API key visibility"
          >
            {showKey ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
</div>

  <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
  {/* Query Description Field */}
  <TextField
    size="small"
    placeholder="Query description"
    value={queryDescription}
    onChange={(e) => {
      setQueryDescription(e.target.value)
      localStorage.setItem('queryDesc', e.target.value)
    }}
    multiline
    minRows={1}
    sx={{
      flex: 1,
      "& .MuiInputBase-root": {
        fontSize: "13px",
        paddingTop: "8px",   // ensure padding for alignment
        paddingBottom: "8px",
      },
    }}
  />
  {/* Generate SQL Button */}
  <button
    onClick={handleAgentAi}
    disabled={loading}
    style={{
      height: "fit-content",   // shrink to match text height
      marginTop: "8px",        // aligns with input text
      backgroundColor: "#9333ea",
      color: "white",
      padding: "6px 12px",
      borderRadius: "6px",
      border: "none",
      fontSize: "13px",
      cursor: "pointer",
      fontWeight: 500,
      whiteSpace: "nowrap",
    }}
  >
    Generate SQL
  </button>
</div>


  {/* FILE CONTROLS */}

  <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
    <input
      type="text"
      placeholder="File name"
      value={fileName}
      onChange={(e) => setFileName(e.target.value)}
      style={{
        padding: "6px",
        borderRadius: "6px",
        border: "1px solid #d1d5db",
        width: "180px",
        fontSize: "13px",
      }}
    />
    <FormControl size="small" sx={{ width: "220px" }}>
    <InputLabel>File Type</InputLabel>
    <Select
      value={fileType}
      onChange={(e) => setFileType(e.target.value)}
      label="LLM Model"
      sx={{
        borderRadius: "6px",
        fontSize: "13px",
        "& .MuiSelect-select": { paddingY: "6px" },
      }}
    >
      <MenuItem value="csv">CSV</MenuItem>
      <MenuItem value="parquet">Parquet</MenuItem>
    </Select>
  </FormControl>

  <button
      onClick={handleExecuteWriteFile}
      disabled={loading}
      style={{
        backgroundColor: "#0ea5e9",
        border: "none",
        color: "white",
        padding: "6px 10px",
        borderRadius: "6px",
        fontSize: "13px",
      }}
    >
      Write To File
    </button>
  </div>

 {/* RESULT TABLE - CLICK TO EXPAND */}
<div
  style={{
    flex: 1,
    marginTop: "14px",
    overflowY: "auto",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#fafafa",
    cursor: "zoom-in",
  }}
  onClick={() => setIsResultModalOpen(true)}
>
  {resultCols.length > 0 ? (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "12px",
      }}
    >
      <thead style={{ backgroundColor: "#f3f4f6", position: "sticky", top: 0 }}>
  <tr>
    {/* Add a new header for the row index */}
    <th
      style={{
        padding: "6px",
        borderBottom: "1px solid #e5e7eb",
        textAlign: "left",
        width: "40px",
      }}
    >
      #
    </th>

    {resultCols.map((col, i) => (
      <th
        key={i}
        style={{
          padding: "6px",
          borderBottom: "1px solid #e5e7eb",
          textAlign: "left",
        }}
      >
        {col}
      </th>
    ))}
  </tr>
</thead>

<tbody>
  {resultRows.map((row, idx) => (
    <tr key={idx}>
      {/* Add a cell with row index (1-based) */}
      <td
        style={{
          padding: "4px",
          borderBottom: "1px solid #f1f5f9",
          color: "#6b7280",
          textAlign: "right",
          fontSize: "0.875rem",
        }}
      >
        {idx + 1}
      </td>

      {row.map((cell, j) => (
        <td
          key={j}
          style={{
            padding: "4px",
            borderBottom: "1px solid #f1f5f9",
            verticalAlign: "top",
          }}
        >
          {String(cell)}
        </td>
      ))}
    </tr>
  ))}
</tbody>

    </table>
  ) : (
    !loading && <p style={{ color: "#9ca3af", textAlign: "center", padding: "8px" }}>No results yet</p>
  )}
</div>
</div>
{isResultModalOpen && (
  <div
    onClick={() => setIsResultModalOpen(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 60,
      right: 50,
      width: "90vw",
      height: "95vh",
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      padding: "20px",
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside table
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
        maxWidth: "95%",
        maxHeight: "90%",
        overflowY: "auto",
        padding: "16px",
      }}
    >
      <button
        onClick={() => setIsResultModalOpen(false)}
        style={{
          position: "absolute",
          top: "3px",
          right: "10px",
          background: "#ef4444",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        ✕ Close
      </button>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "13px",
        }}
      >
        <thead style={{ backgroundColor: "#f3f4f6", position: "sticky", top: 0, zIndex: 1 }}>
          <tr>
            {resultCols.map((col, i) => (
              <th
                key={i}
                style={{ padding: "6px", borderBottom: "1px solid #e5e7eb", textAlign: "left" }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {resultRows.map((row, idx) => (
            <tr key={idx}>
              {row.map((cell, j) => (
                <td
                  key={j}
                  style={{ padding: "4px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" }}
                >
                  {String(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

      </div>
    </div>

    {error && (
  <ErrorDialog
    open={!!error}
    onClose={() => setError(null)}
    message={error}
  />
)}

<Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
  >

  <div
    style={{
      width: "400px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
    >
  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>
  
    </div>

  </div>

</Drawer>


    </div>
  );
}

export default QueryEditorPage;

/*
Get the Sqlite metadata like columns and types 
Add description and save to file

*/

//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